export default __webpack_public_path__ + "static/autonomous_vehicles-26375b0576ed063c1afb89103fb376c0.webp";